import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  HostListener,
  Input,
  Output,
} from '@angular/core';

@Component({
  selector: 'epc-product-title',
  templateUrl: './product-title.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class ProductTitleComponent {
  @Input()
  public title = '';

  @Input()
  public canShowCopyMessage = false;

  @Output()
  public copyQuantities: EventEmitter<void> = new EventEmitter<void>();

  @Output()
  public highlight: EventEmitter<boolean> = new EventEmitter<boolean>();

  public showCopyQuantitiesMessage = false;

  @HostListener('mouseenter')
  public mouseenter() {
    if (!this.canShowCopyMessage) {
      return;
    }

    this.showCopyQuantitiesMessage = true;
    this.highlight.emit(this.showCopyQuantitiesMessage);
  }

  @HostListener('mouseleave')
  public mouseleave() {
    this.showCopyQuantitiesMessage = false;
    this.highlight.emit(this.showCopyQuantitiesMessage);
  }

  public onCopyQuantities() {
    this.copyQuantities.emit();
  }
}
